import { useEffect, useState } from "react";
import {
  Autocomplete,
  Checkbox,
  DatePicker,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  TextFielDecimalNumbers
} from "../../../components";
import { filtrosUrl, value } from "../../../helpers";
import { GrupoPessoasService } from "../../../services";
import { cacheApi, responseErros, unformatPrice } from "../../../utils";

export default function TabColaborador({
  colaboradorSelecionado,
  linhaSelecionada,
  cacheDto,
  setCacheDto,
  inputErros
}) {
  const [listaGrupoPessoa, setListaGrupoPessoa] = useState([]);
  const [colaborador, setColaborador] = useState(colaboradorSelecionado);

  const grupoPessoasService = new GrupoPessoasService();

  useEffect(() => {
    buscaGruposPessoas();
  }, []);

  const buscaGruposPessoas = async () => {
    const filtros = {
      ativado: true,
      tipoPessoa: 4,
      restritiva: true,
    };
    const label = filtrosUrl.getUrl(filtros, grupoPessoasService.urlBase);
    const cacheBody = {
      apiFunction: grupoPessoasService.getAllFiltroAvancado(filtros),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(label, cacheBody);
    if (!res.isAxiosError) {
      setListaGrupoPessoa(res.data.rows);
    } else {
      responseErros(res);
    }
  };

  const handleCheckBoxVendedor = (event) => {
    const checked = event.target.checked;
    colaboradorSelecionado.setAtributo("vendedor", checked);
    if (!checked) {
      colaboradorSelecionado.setAtributo("comissaoVista", null);
      colaboradorSelecionado.setAtributo("comissaoPrazo", null);
    }
    setColaborador({ ...colaboradorSelecionado });
  };

  const handleCheckBoxMotorista = (event) => {
    colaboradorSelecionado.setAtributo("motorista", event.target.checked);
    setColaborador({ ...colaboradorSelecionado });
  };

  const handleChangeData = (prop, data) => {
    if (!data) {
      data = "Invalid Date";
    }
    const value = data != "Invalid Date" ? data : null;
    colaboradorSelecionado.setAtributo(prop, value);
    setColaborador({ ...colaboradorSelecionado });
  };

  const handleChangeAutocomplete = (name, value) => {
    colaboradorSelecionado.setAtributo(name, value?.id);
    setColaborador({ ...colaboradorSelecionado });
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    colaboradorSelecionado.setAtributo(name, value);
    setColaborador({ ...colaboradorSelecionado });
  };

  const handleChangeCurrencyInput = (event) => {
    const { name, value } = event.target;
    const valor = unformatPrice(value);
    colaboradorSelecionado.setAtributo(name, Number(valor));
    setColaborador({ ...colaboradorSelecionado });
  };

  return (
    <Grid container spacing={2} className="mt-1">
      <Grid item xs={12}>
        <div className="d-flex flex-row">
          <FormGroup className="align-items-center">
            <FormControlLabel
              control={
                <Checkbox
                  checked={colaborador?.vendedor ?? false}
                  onClick={handleCheckBoxVendedor}
                  color="primary"
                  value={colaborador?.vendedor}
                  name="vendedor"
                />
              }
              label="Vendedor"
            />
          </FormGroup>
          <FormGroup className="align-items-center">
            <FormControlLabel
              control={
                <Checkbox
                  checked={colaborador?.motorista ?? false}
                  onClick={handleCheckBoxMotorista}
                  color="primary"
                  value={colaborador?.motorista}
                  name="motorista"
                />
              }
              label="Motorista"
            />
          </FormGroup>
        </div>
      </Grid>
      <Grid item xs={3}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="grupoPessoaId"
            name="grupoPessoaId"
            options={listaGrupoPessoa}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            filterSelectedOptions
            onChange={(_, value) => 
              handleChangeAutocomplete("grupoPessoaId", value)
            }
            value={value.autoComplete(
              listaGrupoPessoa,
              colaborador?.grupoPessoaId
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Grupos de Pessoas"
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <TextField
          label="Função"
          name="funcao"
          margin="normal"
          fullWidth
          onChange={handleChangeInput}
          required
          value={colaborador?.funcao ?? ""}
          error={inputErros?.get(`[${linhaSelecionada}].colaborador.funcao`)}
        />
      </Grid>
      <Grid item xs={3}>
        <DatePicker
          label="Data Admissao"
          name="dataAdmissao"
          margin="normal"
          format="dd/MM/yyyy"
          value={colaborador?.dataAdmissao ? colaborador.dataAdmissao : null}
          onChange={(data) => handleChangeData("dataAdmissao", data)}
          error={inputErros.get("dataAdmissao")}
        />
      </Grid>
      <Grid item xs={3}>
        <DatePicker
          label="Data Demissão"
          name="dataDemissao"
          margin="normal"
          format="dd/MM/yyyy"
          value={colaborador?.dataDemissao ? colaborador.dataDemissao : null}
          onChange={(data) => handleChangeData("dataDemissao", data)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextFielDecimalNumbers
          name="descontoMaximo"
          label="Desconto máximo"
          margin="none"
          variant={colaborador?.vendedor ? "outlined" : "filled"}
          disabled={!colaborador?.vendedor}
          value={colaborador?.descontoMaximo ?? ""}
          onBlur={handleChangeCurrencyInput}
          error={inputErros.get("descontoMaximo")}
          fullWidth
        />
      </Grid>
      <Grid item xs={2}>
        <TextFielDecimalNumbers
          label="Comissão - A Prazo"
          name="comissaoPrazo"
          margin="none"
          disabled={!colaborador?.vendedor}
          variant={colaborador?.vendedor ? "outlined" : "filled"}
          fullWidth
          onBlur={handleChangeCurrencyInput}
          value={colaborador?.comissaoPrazo ?? ""}
          error={inputErros.get("comissaoPrazo")}
        />
      </Grid>
      <Grid item xs={2}>
        <TextFielDecimalNumbers
          label="Comissão - A Vista"
          name="comissaoVista"
          margin="none"
          disabled={!colaborador?.vendedor}
          variant={colaborador?.vendedor ? "outlined" : "filled"}
          fullWidth
          onBlur={handleChangeCurrencyInput}
          value={colaborador?.comissaoVista ?? ""}
          error={inputErros.get("comissaoVista")}
        />
      </Grid>
    </Grid>
  );
}
